/**
 * Created by cq on 2018/8/9.
 */
const Config = require('./Config');

module.exports = {
  Config,
};
